import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/buying/LeftMenu';
import Feature from '../components/buying/Feature';
import ContactUs from '../components/ContactUs';
import BuyForOfferMachine from '../components/BuyForOfferMachine';

const AuctionProcess = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('buying'),
      url: '/content/buying/before-bidding',
    },
    {
      label: 'Açık Artırma Nedir?',
      url: '/content/buying/auction-process',
    },
  ];

  const items = [
    {
      title: 'Online Teklif Kolaylığı',
      description: 'Kullanıcılar, almak istedikleri makinaya online açık artırmaya katılarak Türkiye\'nin her ilinden online olarak teklif verebilirler. Makinaya istedikleri teklifi vererek piyasa değerinde satın alma şansına sahip olurlar.',
      icon: 'fa-solid fa-hand-holding-dollar',
    },
    {
      title: 'Güvenilir ve Şeffaf Fiyat Teklifi',
      description: 'Açık artırmalara katılmak isteyen katılımcılardan Teminat Bedeli temin edilir. Manipülasyonu engellemek ve güveni sağlamak amacıyla yapılan bu işlem, kullanıcıların teklif verdiği makinalar için verilen teklifin ciddiyetini gösterir.',
      icon: 'fa-solid fa-shield',
    },
    {
      title: '30 Gün İçinde Satış ve Devir',
      description: 'Düzenlediğimiz açık artırmalar ortalama 30 gün içinde sonuçlanır. Satın alınan makinanın ödemesi yapıldığı takdirde, kullanıcılar kolayca makina sahibi olurlar. Mali, hukuki ve operasyonel işlerin tamamını iyiMakina.com halleder.',
      icon: 'fa-solid fa-handshake',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="auction-process" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Açık Artırma Nedir?</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  iyiMakina.com üzerinden satışa çıkan makinalar online açık artırmalara dahil olur.
                  Makinaları satın almak isteyen alıcılar, online açık artırmalar aracılığıyla istedikleri makinaya, istedikleri fiyatı teklif ederler.
                  Alıcılar önceki teklifleri artırarak yeni teklifler verebilirler ve bu teklifler sonucunda; açık artırma bittiğinde en yüksek teklifi veren kullanıcı açık artırmanın kazananı olur.
                </p>
                <p>
                  iyiMakina.com'da gerçekleşen tüm açık artırmalar önceden duyurulan gün ve saatte online olarak yapılır.
                  Açık artırma katılımcılarının ödediği Teminat Bedeli aracılığıyla, manipülasyon olmadan, güvenli ve hızlı alım-satım gerçekleşir.
                </p>
              </div>
            </div>
            <div className="row mb-30 align-items-stretch">
              {
                _.map(items, (item, index) => (
                  <Feature key={index} data={item} />
                ))
              }
            </div>
            <BuyForOfferMachine />
            <ContactUs about="Açık Artırma Süreciyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

AuctionProcess.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Açık Artırma Süreci',
    },
  };
};

AuctionProcess.Layout = Layout;

export default withTranslation('common')(AuctionProcess);
